import { dateToShow, dateToMysql } from '@/helpers/dates'
import days from './days'
import moment from 'moment'
import { error } from '@/utils/alert'

const prepareSave = rule => {
  rule.valid_to_start = dateToMysql(rule.valid_to_start)
  rule.valid_to_end = dateToMysql(rule.valid_to_end)

  const isAfter = moment(rule.valid_to_end).isAfter(rule.valid_to_start)

  if (!isAfter) {
    error('A data final precisa se maior que a data inicial')
    rule.valid_to_end = ''
    return rule
  }

  return rule
}

const prepareShow = rule => {
  rule.valid_to_start = dateToShow(rule.valid_to_start)
  rule.valid_to_end = dateToShow(rule.valid_to_end)
  rule.days = days(rule)
  rule.time_start = rule.time_start.slice(0, 5)
  rule.time_end = rule.time_end.slice(0, 5)

  // verificando se existe segundo horarios
  if ((rule.time_start_two !== null) && (rule.time_end_two !== null)) {
    rule.time_start_two = rule.time_start_two.slice(0, 5)
    rule.time_end_two = rule.time_end_two.slice(0, 5)
  }

  return rule
}

export default {
  prepareSave,
  prepareShow
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/methods.js